import { UserRole } from "@employee-management/common";
import { Plus } from "lucide-react";
import { useState } from "react";
import { ProtectedRoute } from "@/components/auth/protected-route";
import { Button } from "@/components/ui/button";
import { PageHeading } from "@/components/ui/page-heading";
import {
  SearchFilterBar,
  type FilterSettings,
} from "@/components/ui/search-filter-bar";
import { UserCreateDialog } from "./components/UserCreateDialog/UserCreateDialog";
import { UserTable } from "./components/UserTable/UserTable";

export function UserListView() {
  const [open, setOpen] = useState(false);
  const [filterSettings, setFilterSettings] = useState<FilterSettings>({
    searchTerm: "",
    filters: {},
  });

  const filterOptions = [
    {
      key: "role",
      label: "Role",
      type: "select" as const,
      options: [
        { value: UserRole.SUPERADMIN, label: "Super Admin" },
        { value: UserRole.MANAGER, label: "Manager" },
        { value: UserRole.SUPERVISOR, label: "Supervisor" },
      ],
    },
    {
      key: "isActive",
      label: "Status",
      type: "select" as const,
      options: [
        { value: "true", label: "Active" },
        { value: "false", label: "Inactive" },
      ],
    },
    {
      key: "createdAt",
      label: "Created Date",
      type: "range" as const,
      rangeType: "date" as const,
    },
  ];

  return (
    <ProtectedRoute requiredRole={UserRole.SUPERADMIN}>
      <div>
        <PageHeading
          title="Users"
          subtitle="Manage system users and their roles."
          actions={
            <Button onClick={() => setOpen(true)}>
              <Plus className="h-4 w-4" />
              Add User
            </Button>
          }
          className="mb-6"
        />

        <SearchFilterBar
          filterOptions={filterOptions}
          placeholder="Search users by name or email..."
          onFilterChange={setFilterSettings}
          className="mb-6"
        />

        <UserCreateDialog open={open} onOpenChange={setOpen} />
        <UserTable filterSettings={filterSettings} />
      </div>
    </ProtectedRoute>
  );
}
